import React, { useEffect, useState } from 'react';
import { apiPost, apiGet } from '../../api';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

const EditModerator = () => {
  const { id } = useParams();
  const [form, setForm] = useState({ name: '', email: '', role: '' });
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchModeratorAndRoles = async () => {
      try {
        // Fetch roles
        const rolesRes = await apiGet('/api/admin/roles/list?page=1&pageSize=100&order=null', {});
        setRoles(rolesRes.data.data.data || []);
        // Fetch moderator
        const res = await apiGet(`/api/admin/moderators/list?status=Active&page=1&pageSize=100&order=desc`);
        const found = (res.data.data.data || []).find(m => m._id === id);
        if (!found) throw new Error('Moderator not found');
        setForm({ name: found.name, email: found.email, role: found.role || '' });
      } catch (err) {
        toast.error('Failed to fetch moderator or roles');
      }
    };
    fetchModeratorAndRoles();
    // eslint-disable-next-line
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiPost('/api/admin/moderators/edit', { ...form, moderatorId: id });
      toast.success('Moderator updated successfully');
      navigate('/moderators');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update moderator');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Management
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground mb-6">Edit <span className="text-gradient-ginox">Moderator</span></h1>

      <form onSubmit={handleSubmit}>
        <div className="p-5 mb-6 space-y-4">
          {/* Name */}
          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              placeholder="Full name"
              required
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              placeholder="email@example.com"
              required
            />
          </div>

          {/* Role */}
          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Role
            </label>
            <select
              name="role"
              value={form.role}
              onChange={handleChange}
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
            >
              <option value="">Select Role</option>
              {roles.map(r => (
                <option key={r._id} value={r.role}>{r.role}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            type="submit"
            className="rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
          <button
            type="button"
            className="rounded-md border border-border/70 bg-white/[0.02] px-4 py-2 text-xs text-muted-foreground hover:bg-white/[0.05] hover:text-foreground transition-colors"
            onClick={() => navigate('/moderators')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditModerator;
